import React from 'react';
import { connect } from 'react-redux';

import EmailVerificationModal from './EmailModal';
import PhoneVerificationModal from './PhoneModal';

interface Props {
  dispatch: any;
  modalStyle: any;
  showEmailVerifyModal: boolean;
  showPhoneVerifyModal: boolean;
  token: string;
  user: any;
}
export class VerificationModal extends React.Component<Props> {
  render() {
    const {
      dispatch,
      showEmailVerifyModal,
      showPhoneVerifyModal,
      modalStyle,
      token,
      user,
    } = this.props;
    return (
      <React.Fragment>
        <EmailVerificationModal
          email={user.email}
          dispatch={dispatch}
          showEmailVerifyModal={showEmailVerifyModal}
          token={token}
          modalStyle={modalStyle}
        />
        <PhoneVerificationModal
          phoneNumber={user.phoneNumber}
          dispatch={dispatch}
          showPhoneVerifyModal={showPhoneVerifyModal}
          token={token}
          modalStyle={modalStyle}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    user: state.auth.user,
    showEmailVerifyModal: state.dashboard.showEmailVerifyModal,
    showPhoneVerifyModal: state.dashboard.showPhoneVerifyModal,
    token: state.auth.token,
  };
};
export default connect(mapStateToProps)(VerificationModal);
